module.exports = __webpack_public_path__ + "static/media/silkycloud-silver-4.837b112e.png";